import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
  phone: "",
  password: "",
  confirmPassword: "",
  token: "",
  referralCode: "",
  countryCode: "+1",
  signUpSuccess: false,
  phoneVerification: "",
  userVerified: false,
  profileSuccess: false,
  countryFlag: "flags/USA",
  forgotPasswordSuccess: false,
  termsConditions: false,
  userId: "",
  logOutSuccess: "",
  alpha3Code: "USA",
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.PHONE_NUMBER_CHANGED:
      // const { name } = action.payload;
      return {
        ...state,
        phone: action.payload
      };

    case actions.PASSWORD_CHANGED:
      // const { name } = action.payload;
      return {
        ...state,
        password: action.payload
      };

    case actions.REFERRAL_CODE_CHANGED:
      // const { name } = action.payload;
      return {
        ...state,
        referralCode: action.payload
      };

    case actions.COUNTRY_CODE_CHANGED:
      return {
        ...state,
        countryCode: action.payload.code,
        countryFlag: action.payload.countryFlag,
        alpha3Code: action.payload.alpha3Code,
      };
    case actions.CONFIRM_PASSWORD_CHANGED:
      // const { name } = action.payload;
      return {
        ...state,
        confirmPassword: action.payload
      };
    case actions.SIGNIN_REQUEST_SUCCESS:
      return {
        ...state,
        logOutSuccess: "",
        ...action.payload,
      }
    case actions.PHONE_VERIFICATION_CHANGE:
      return {
        ...state,
        phoneVerification: action.payload
      }
    case actions.SIGNUP_REQUEST_SUCCESS:
      return {
        ...state,
        signUpSuccess: true,
        phone: "",
        password: "",
        confirmPassword: "",
        token: "",
        referralCode: "",
        countryCode: "",
        logOutSuccess: "",
        ...action.payload
      }
    case actions.PHONE_VERIFICATION_REQUEST_SUCCESS:
      return {
        ...state,
        userVerified: action.payload
      }
    case actions.SIGNUP_PROFILE_SUCCESS:
      return {
        ...state,
        profileSuccess: true,
      }
    case actions.FORGOT_PASSWORD_REQUEST_SUCCESS:
      return {
        ...state,
        forgotPasswordSuccess: action.payload.forgotPasswordState,
        userId: action.payload.userId,
      }
    case actions.TERMS_CONDITIONS_CHANGE:
      return {
        ...state,
        termsConditions: action.payload,
      }
    case actions.LOGOUT_REQUEST_SUCCESS:
      return {
        ...state,
        logOutSuccess: true,
      }
    case actions.LOGOUT_REQUEST_FAIL:
      return {
        ...state,
        logOutSuccess: false,
      }
    case actions.RESET_PHONE_AND_PASSWORD:
      return {
        ...state,
        phone: "",
        password: "",
      }
    default:
      return state;
  }
};
